"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.cssAnchorName = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _preactPortal = _interopRequireDefault(require("preact-portal"));

var _CategoryFilterBox = _interopRequireDefault(require("./CategoryFilterBox"));

var _classnames = _interopRequireDefault(require("classnames"));

var _categories = require("@insided/shared/utils/categories");

var _shared = require("../shared");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var cssAnchorName = 'widget-category_filter';
exports.cssAnchorName = cssAnchorName;

var WidgetCategoryFilter = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(WidgetCategoryFilter, _Component);

  var _super = _createSuper(WidgetCategoryFilter);

  function WidgetCategoryFilter() {
    var _this$props$selectedC;

    var _this;

    (0, _classCallCheck2.default)(this, WidgetCategoryFilter);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      categories: _this.props.categories,
      selectedCategory: (_this$props$selectedC = _this.props.selectedCategory) !== null && _this$props$selectedC !== void 0 ? _this$props$selectedC : null,
      appliedSelectedCategory: null,
      portal: false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "selectCategory", function (id) {
      var isContainer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (isContainer && id) {
        _this.setState(function (_ref) {
          var categories = _ref.categories;
          return {
            categories: (0, _categories.toggleCollapseCategory)(categories, Number(id))
          };
        });

        return;
      }

      _this.setState({
        selectedCategory: id
      });

      (0, _shared.updateQueryFilters)({
        category: id ? [id] : null
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "updatePortalSetting", function (evt) {
      _this.setState(function (prevState) {
        return {
          appliedSelectedCategory: prevState.selectedCategory,
          portal: evt.detail.display
        };
      });
    });
    return _this;
  }

  (0, _createClass2.default)(WidgetCategoryFilter, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var _this$state = this.state,
          categories = _this$state.categories,
          selectedCategory = _this$state.selectedCategory;

      if (typeof window === 'undefined') {
        return;
      }

      window.addEventListener('filter', this.updatePortalSetting);
      window.addEventListener('resetFilters', function () {
        return _this2.selectCategory(null);
      });
      window.addEventListener('revertFilters', function () {
        return _this2.selectCategory(_this2.state.appliedSelectedCategory);
      });
      window.addEventListener('categoryFilterRemoval', function () {
        return _this2.selectCategory(null);
      });

      if (selectedCategory) {
        var category = (0, _categories.findCategoryById)(categories, Number(selectedCategory));

        if (category !== null && category !== void 0 && category.parentId) {
          this.setState(function (_ref2) {
            var categories = _ref2.categories;
            return {
              categories: (0, _categories.toggleCollapseCategory)(categories, category === null || category === void 0 ? void 0 : category.parentId)
            };
          });
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this3 = this;

      if (typeof window === 'undefined') {
        return;
      }

      window.removeEventListener('filter', this.updatePortalSetting);
      window.removeEventListener('resetFilters', function () {
        return _this3.selectCategory(null);
      });
      window.removeEventListener('revertFilters', function () {
        return _this3.selectCategory(_this3.state.appliedSelectedCategory);
      });
      window.removeEventListener('categoryFilterRemoval', function () {
        return _this3.selectCategory(null);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state2 = this.state,
          categories = _this$state2.categories,
          portal = _this$state2.portal;
      return (0, _preact.h)("div", null, (0, _preact.h)(_CategoryFilterBox.default, {
        className: (0, _classnames.default)('box__content', 'box__pad', 'ideation-filters', 'is-hidden-M', 'category-filter'),
        categories: categories,
        selectedCategory: this.state.selectedCategory,
        onSelect: this.selectCategory
      }), Boolean(portal) && (0, _preact.h)(_preactPortal.default, {
        into: ".instant-search__results-wrapper-filters"
      }, (0, _preact.h)(_CategoryFilterBox.default, {
        className: (0, _classnames.default)('box__content', 'box__pad', 'ideation-filters', 'category-filter'),
        categories: categories,
        selectedCategory: this.state.selectedCategory,
        onSelect: this.selectCategory
      })));
    }
  }]);
  return WidgetCategoryFilter;
}(_preact.Component);

var _default = WidgetCategoryFilter;
exports.default = _default;